import * as React from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Кнопка действия («Создать тариф», «Сбросить фильтры»). */
  action?: React.ReactNode;
  className?: string;
}

/** «Ничего нет» — отдельно от ошибки загрузки (ErrorState). */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-2 px-4 py-12 text-center', className)}>
      {icon && (
        <div className="mb-1 grid size-12 place-items-center rounded-2xl bg-muted text-text-2 [&_svg]:size-6">
          {icon}
        </div>
      )}
      <p className="font-display text-base font-bold text-text">{title}</p>
      {description && <p className="max-w-sm text-sm text-text-2">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
